import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { LOCATION_TYPE_CATEGORY_NODE_FRAGMENT } from '../fragments'

const REPLACE_LOCATION_TYPE_MUTATION = gql`
  mutation replaceLocationType($idToReplace: ID!, $replacementId: ID!) {
    replaceLocationType(
      idToReplace: $idToReplace
      replacementId: $replacementId
    ) {
      results {
        ...LocationTypeCategoryNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${LOCATION_TYPE_CATEGORY_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default REPLACE_LOCATION_TYPE_MUTATION
